module.exports = __webpack_public_path__ + "static/img/medical_666.58cf1341.png";